// Redux actions for SocketMessage handling

export const SET_SOCKET_MESSAGE = 'SET_SOCKET_MESSAGE';
export const CLEAR_SOCKET_MESSAGE = 'CLEAR_SOCKET_MESSAGE';
export const SET_SOCKET_MESSAGE_ERROR = 'SET_SOCKET_MESSAGE_ERROR';
export const SET_EXCHANGE_MESSAGE = 'SET_EXCHANGE_MESSAGE';
export const CLEAR_EXCHANGE_MESSAGES = 'CLEAR_EXCHANGE_MESSAGES';

// Action to set socket message
export const setSocketMessageAction = (messageData) => ({
  type: SET_SOCKET_MESSAGE,
  payload: messageData
});

// Action to clear socket message
export const clearSocketMessageAction = () => ({
  type: CLEAR_SOCKET_MESSAGE
});

// Action to set socket message error
export const setSocketMessageErrorAction = (error) => ({
  type: SET_SOCKET_MESSAGE_ERROR,
  payload: error
});

// Action to set exchange-specific message
export const setExchangeMessageAction = (exchange, messageData) => ({
  type: SET_EXCHANGE_MESSAGE,
  payload: { exchange, messageData }
});

// Action to clear exchange messages
export const clearExchangeMessagesAction = (exchange = null) => ({
  type: CLEAR_EXCHANGE_MESSAGES,
  payload: exchange // null means clear all exchanges
});

// Enhanced async action to process and store socket message
export const processSocketMessageAction = (message) => {
  return (dispatch) => {
    try {
      console.log('📨 Processing SocketMessage for Redux:', message);

      // Store the message with enhanced timestamp
      const processedMessage = {
        ...message,
        receivedAt: new Date().toISOString(),
        timestamp: message.timestamp || Date.now(),
        id: `${message.exchange}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
      };

      // Store in general socket message store
      dispatch(setSocketMessageAction(processedMessage));

      // Store in exchange-specific store if exchange is specified
      if (message?.exchange) {
        dispatch(setExchangeMessageAction(message.exchange, processedMessage));
      }


      // Special handling for MCX margin messages
      if (message?.exchange === 'MCX' &&
        (message?.genericMessage?.includes('special/additional margin calculation') ||
          message?.bodMessage?.includes('special/additional margin calculation'))) {
        console.log('🎯 MCX Special Margin Message received:', {
          exchange: message.exchange,
          marketStatus: message.marketStatus,
          sessionTime: message.currentSession?.[0]?.sessionTime,
          marginMessage: message.genericMessage || message.bodMessage
        });
      }

    } catch (error) {
      console.error('❌ Error processing SocketMessage:', error);
      dispatch(setSocketMessageErrorAction(error.message));
    }
  };
}; 